"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ButtonTimePicker',
  components: {},
  mixins: [],
  props: {},
  data: function data() {
    return {
      timeVal: [],
      // 时间段
      timeType: 'lately30',
      // 时间单选框时间类型
      timeFromList: [{
        text: '今天',
        val: 'today'
      }, {
        text: '昨天',
        val: 'yesterday'
      }, {
        text: '最近7天',
        val: 'lately7'
      }, {
        text: '最近30天',
        val: 'lately30'
      }, {
        text: '本月',
        val: 'month'
      }, {
        text: '本年',
        val: 'year'
      }],
      // 时间选择器选项
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          var startDate = new Date();
          startDate.setTime(startDate.getTime() - 364 * 24 * 60 * 60 * 1000);
          startDate.setHours(0, 0, 0, 0);
          return time.getTime() < startDate.getTime() || time.getTime() > today.getTime();
        }
      }
    };
  },
  computed: {},
  watch: {
    timeVal: function timeVal(nVal) {
      if (nVal) {
        this.$emit('dateRangeChange', nVal);
      }
    }
  },
  created: function created() {
    // 初始化时间选择器范围为最近七天
    this.changeTimeRange();
  },
  methods: {
    //格式化日期为 YYYY-MM-DD
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    // 修改时间范围
    changeTimeRange: function changeTimeRange() {
      var endDate = new Date();
      var startDate = new Date();
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth();
      switch (this.timeType) {
        case 'today':
          this.timeVal = [this.formatDate(startDate), this.formatDate(endDate)];
          break;
        case 'yesterday':
          startDate.setDate(endDate.getDate() - 1);
          endDate.setDate(endDate.getDate() - 1);
          this.timeVal = [this.formatDate(startDate), this.formatDate(endDate)];
          break;
        case 'lately7':
          startDate.setDate(endDate.getDate() - 6);
          this.timeVal = [this.formatDate(startDate), this.formatDate(endDate)];
          break;
        case 'lately30':
          startDate.setDate(endDate.getDate() - 29);
          this.timeVal = [this.formatDate(startDate), this.formatDate(endDate)];
          break;
        case 'month':
          // 本月第一天
          var firstDayInMonth = new Date(year, month, 1);
          // 当天
          var lastDayInMonth = new Date(year, month, now.getDate());
          this.timeVal = [this.formatDate(firstDayInMonth), this.formatDate(lastDayInMonth)];
          break;
        case 'year':
          // 本年第一天：1月1日
          var firstDayInYear = new Date(year, 0, 1);
          // 当天
          var lastDayInYear = new Date(year, now.getMonth(), now.getDate());
          this.timeVal = [this.formatDate(firstDayInYear), this.formatDate(lastDayInYear)];
          break;
      }
    },
    // 修改时间选择器
    timeChange: function timeChange(value) {
      this.timeType = '';
    }
  }
};